var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgCustomersAll = function SvgCustomersAll(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.857 14.6429C20.1587 15.9447 20.1587 18.0552 18.857 19.357C17.5552 20.6587 15.4447 20.6587 14.1429 19.357C12.8412 18.0552 12.8412 15.9447 14.1429 14.6429C15.4447 13.3412 17.5552 13.3412 18.857 14.6429",
    stroke: "#8E8E93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1717 6.643C27.4734 7.94475 27.4734 10.0553 26.1717 11.357C24.8699 12.6588 22.7594 12.6588 21.4576 11.357C20.1559 10.0553 20.1559 7.94474 21.4576 6.643C22.7594 5.34125 24.8699 5.34125 26.1717 6.643",
    stroke: "#8E8E93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 16.3334C26.544 16.3334 28.5 17.044 29.8333 18.1107",
    stroke: "#8E8E93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5423 6.643C12.844 7.94475 12.844 10.0553 11.5423 11.357C10.2405 12.6588 8.12999 12.6588 6.82824 11.357C5.52649 10.0553 5.52649 7.94474 6.82824 6.643C8.12999 5.34125 10.2405 5.34125 11.5423 6.643",
    stroke: "#8E8E93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.16663 18.1107C4.49996 17.044 6.45596 16.3334 8.49996 16.3334",
    stroke: "#8E8E93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6213 26.3334C21.068 25.132 18.836 24.3334 16.5 24.3334C14.164 24.3334 11.932 25.132 10.3787 26.3334",
    stroke: "#8E8E93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgCustomersAll;